import React, { useRef, useState } from 'react';
import {
  Button, Form, Overlay, OverlayTrigger, Popover, Tooltip,
} from 'react-bootstrap';
import { clampDiscount } from '../salesUtils';
import styles from './SalesTable.module.scss';

interface SetAllDiscountsButtonProps {
  disabled?: boolean;
  onApply: (discountPercent: number) => void;
}

export function SetAllDiscountsButton(props: SetAllDiscountsButtonProps) {
  const { disabled, onApply } = props;
  const triggerRef = useRef<HTMLSpanElement>(null);
  const [show, setShow] = useState(false);
  const [tooltipHover, setTooltipHover] = useState(false);
  const [value, setValue] = useState('0');

  const handleApply = () => {
    onApply(clampDiscount(parseInt(value, 10)));
    setShow(false);
  };

  const handlePopoverToggle = (nextShow: boolean) => {
    setShow(nextShow);
    if (nextShow) {
      setTooltipHover(false);
    }
  };

  const popover = (
    <Popover id="set-all-discounts" className={styles.setAllDiscountsPopover}>
      <Popover.Title as="h3">Discount %</Popover.Title>
      <Popover.Content>
        <Form.Group className="mb-2">
          <Form.Control
            type="number"
            min={0}
            max={100}
            step={1}
            value={value}
            onChange={(event) => setValue(event.target.value)}
            aria-label="Discount percent"
          />
        </Form.Group>
        <Button
          type="button"
          variant="primary"
          size="sm"
          onClick={handleApply}
        >
          Set all answers
        </Button>
      </Popover.Content>
    </Popover>
  );

  const tooltip = (
    <Tooltip id="set-all-discounts-tooltip">
      Set discount percent for all answers
    </Tooltip>
  );

  return (
    <>
      <span
        ref={triggerRef}
        className={styles.setAllDiscountsTrigger}
        onMouseEnter={() => {
          if (!show) {
            setTooltipHover(true);
          }
        }}
        onMouseLeave={() => setTooltipHover(false)}
      >
        <OverlayTrigger
          trigger="click"
          placement="bottom"
          rootClose
          show={show}
          onToggle={handlePopoverToggle}
          container={typeof document === 'undefined' ? undefined : document.body}
          overlay={popover}
        >
          <Button
            type="button"
            variant="outline-secondary"
            size="sm"
            disabled={disabled}
            aria-label="Set discount percent for all answers"
          >
            %
          </Button>
        </OverlayTrigger>
      </span>
      <Overlay
        target={() => triggerRef.current}
        show={tooltipHover && !show}
        placement="top"
        container={typeof document === 'undefined' ? undefined : document.body}
      >
        {tooltip}
      </Overlay>
    </>
  );
}
